import { render } from "./ArrowToRight.vue?vue&type=template&id=74911e08"
import script from "./ArrowToRight.vue?vue&type=script&lang=js"
export * from "./ArrowToRight.vue?vue&type=script&lang=js"
script.render = render

export default script